import { j as jsxRuntimeExports } from "./auth-service-tools177.js";
import { rem } from "./auth-service-tools172.js";
import "react";
import { getDefaultZIndex } from "./auth-service-tools182.js";
import { getRadius } from "./auth-service-tools185.js";
import { createVarsResolver } from "./auth-service-tools191.js";
import { rgba } from "./auth-service-tools212.js";
import { useProps } from "./auth-service-tools225.js";
import { useStyles } from "./auth-service-tools198.js";
import { Box } from "./auth-service-tools244.js";
import { polymorphicFactory } from "./auth-service-tools249.js";
import classes from "./auth-service-tools283.js";
const defaultProps = {
  zIndex: getDefaultZIndex("modal")
};
const varsResolver = createVarsResolver((_, _ref) => {
  let {
    gradient,
    color,
    backgroundOpacity,
    blur,
    radius,
    zIndex
  } = _ref;
  return {
    root: {
      "--overlay-bg": gradient || (color !== void 0 || backgroundOpacity !== void 0) && rgba(color || "#000", backgroundOpacity != null ? backgroundOpacity : 0.6) || void 0,
      "--overlay-filter": blur ? `blur(${rem(blur)})` : void 0,
      "--overlay-radius": radius === void 0 ? void 0 : getRadius(radius),
      "--overlay-z-index": zIndex == null ? void 0 : zIndex.toString()
    }
  };
});
const Overlay = polymorphicFactory((_props, ref) => {
  const props = useProps("Overlay", defaultProps, _props);
  const {
    classNames,
    className,
    style,
    styles,
    unstyled,
    vars,
    fixed,
    center,
    children,
    radius,
    zIndex,
    gradient,
    blur,
    color,
    backgroundOpacity,
    mod,
    ...others
  } = props;
  const getStyles = useStyles({
    name: "Overlay",
    props,
    classes,
    className,
    style,
    classNames,
    styles,
    unstyled,
    vars,
    varsResolver
  });
  return /* @__PURE__ */jsxRuntimeExports.jsx(Box, {
    ref,
    ...getStyles("root"),
    mod: [{
      center,
      fixed
    }, mod],
    ...others,
    children
  });
});
Overlay.classes = classes;
Overlay.displayName = "@mantine/core/Overlay";
export { Overlay };